export enum LastInspectionDateSource {
  InspectionReport = 1,
  Manual = 2,
}
